export default __webpack_public_path__ + "assets/audio/plasticmemories.0c30b956.m4a";